import { Card, Flex, Image, Typography, theme } from "antd";
import { CSSProperties } from "react";

const { Title, Text } = Typography;
const { useToken } = theme;

type Props = {
  style?: CSSProperties;
  icon: string;
  title: string;
  description: string;
};

export const Welcome = ({ style, icon, title, description }: Props) => {
  const { token } = useToken();

  return (
    <Card
      bordered={false}
      style={{
        background: token.colorFillTertiary,
        borderRadius: 8,
        ...style,
      }}
      styles={{
        body: {
          padding: "20px 24px",
        },
      }}
    >
      <Flex
        gap={16}
        align="center"
      >
        {/* Ícone */}
        <Image
          src={icon}
          alt="icon"
          preview={false}
          width={48}
          height={48}
          style={{
            objectFit: "contain",
          }}
        />

        {/* Conteúdo */}
        <Flex
          vertical
          justify="center"
          gap={4}
        >
          <Title
            level={4}
            style={{
              margin: 0,
              fontWeight: 500,
              fontSize: 16,
              lineHeight: "24px",
              color: token.colorText,
            }}
          >
            {title}
          </Title>

          <Text
            style={{
              fontSize: 14,
              lineHeight: "22px",
              color: token.colorTextSecondary,
            }}
          >
            {description}
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};
